import React from 'react';
import MajorCategories from '../../majorcategories/mobile';
import translate from '../../../../utils/translate';
import MenuItem from '../menuitem';

export default class HeaderMobileMenu extends React.Component {
  static propTypes = {
    topLinks: React.PropTypes.array
  };

  constructor (props) {
    super(props);
    const getSiteSection = window.location.pathname.split('/')[1];

    this.state = {
      siteSection: getSiteSection,
      account:     getSiteSection === 'myAccount',
      categories:  true
    };
  }

  toggleAccountPanel = () => {
    this.setState({
      account: !this.state.account
    });
  };

  toggleCategoriesPanel = () => {
    this.setState({
      categories: !this.state.categories
    });
  };

  renderTopLinks = () => {
    return this.props.topLinks.map((link, idx) => <li key={idx}>
      <a className="menuitem__link" href={link.url}>
        {link.name} <i className="menuitem__header__icon--link" />
      </a>
    </li>);
  };

  render () {
    return (
      <ul className="menuaccordion">
        <MenuItem
          type="categories"
          title={translate('categoryNavigationModule', 'CATEGORIES')}
          isActive={this.state.categories}
          onClick={this.toggleCategoriesPanel}
        >
          <MajorCategories {...this.props} />
        </MenuItem>

        {this.renderTopLinks()}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/mobile/menu/index.js